import axios from "axios";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {calculateQueryString} from "../helpers/apiHelpers";

/*** Queries **********************/

const _fetcher = (baseUrl, cartId = null, includes = [], query = {}) => {
    const uri = (cartId) ? `/${cartId}` : '';
    let queryStr = calculateQueryString({includes: includes, ...query})
    return axios.get(`${baseUrl}${uri}${queryStr}`)
        .then(res => {
            return res.data
        });
}

export function useCartQuery({cartId = null, fetcher = _fetcher, queryOptions = {}}) {
    return useQuery(['carts', cartId], () => fetcher('/api/protected/carts', cartId), {refetchInterval: 10000, ...queryOptions});
}

export function useCartMineQuery({fetcher = _fetcher, queryOptions = {}}) {
    return useQuery(['carts', 'mine'], () => fetcher('/api/protected/carts/mine'), {refetchInterval: 10000, ...queryOptions});
}

export function useCartRefCodeQuery({refCode = null, fetcher = _fetcher, queryOptions = {}}) {
    return useQuery(['reference_code', refCode], () => fetcher('/api/refcode/', refCode), {refetchInterval: 10000, ...queryOptions}); //TODO CAmbiare url
}

/*** Mutations **********************/


export const createCartMutation = () => {
    return axios.post(`/api/protected/carts`)
        .then(res => res.data)
}


export const useCreateCartMutation = (options = {}) => {
    return useMutation(['create-cart'], (params) => createCartMutation(params), options);
}

export const updateCartMutation = async (params) => {
    const {cartId, data} = params
    // if (data.item_lines.length > 0) {
    //     data.item_lines[0].id = generateGuid()
    //     data.item_lines[0]?.assets.push({
    //         "id": generateGuid(),
    //         "value": "dominio.com",
    //         "type": "Domain"})
    // }
    return await axios.put(`/api/protected/carts/${cartId}`, data)
        .then(res => res);
}

export const useUpdateCartMutation = (mutator = updateCartMutation) => {
    const queryClient = useQueryClient()
    return useMutation(
        ['update-cart'],
        (params) => mutator(params),
        {onSuccess: () => queryClient.invalidateQueries(['carts'])}
    );
}